export default {
  /**
   * @param {*要判断的参数值} value
   * 是否是数值
   */
  isNumber (value) {
    let reg = new RegExp('^[0-9]*$')
    return reg.test(value)
  },
  /**
   *
   * @param {*要判断的参数值} value
   * 是否是邮箱
   */
  isEmail (value) {
    var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
    return reg.test(value)
  },

  /**
   * Check value is taiwan mobile
   *
   * @param value
   */
  mobile: (value) => /^09[0-9]{8}$/.test(value),

  /**
   * 判斷是否為浮點數
   *
   * @param Number value
   * @returns boolean
   */
  isFloat (value) {
    return Number(value) === value && value % 1 !== 0
  },

  /**
   * 判斷是否為布林值
   *
   * @param {any} value
   * @returns {boolean}
   */
  isBoolean (value) {
    return typeof value === 'boolean'
  }
}
